module.exports = __webpack_public_path__ + "resources/audio-call-05d2b30368a803c649a9a2de8c84d20f.svg";